export const AUTH_DOMAIN_NAME = `${process.env.API_URL}`